var Highcharts = require('highcharts/highstock');
require('highcharts/highcharts-more')(Highcharts);

var LiveChart = function(chartData) {
    /*eslint-disable */
    var liveChart = this;
    /*eslint-enable */
    var digits;

    var ctx = document.getElementById('live-chart');

    this.data = {
        labels: chartData.labels,
        symbol: chartData.symbol,
        dateFormat: chartData.dateFormat,
        datasets: [
            {
                label: chartData.title,
                backgroundColor: chartData.colors.colorRgba,
                borderColor: chartData.colors.colourRgb,
                borderWidth: 1,
                data: chartData.data,
                ranges: chartData.ranges,
                pointBorderColor: 'transparent',
                pointBackgroundColor: 'transparent',
                pointBorderWidth: 1,
                pointHoverRadius: 6,
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: '#ccc',
                pointHoverBorderWidth: 1,
                steppedLine: false
            }
        ]
    };

    this.getDigits = function(value) {
        if (value > 0) {
            digits = 5;
        }
        if (value >= 0.1) {
            digits = 4;
        }
        if (value >= 1) {
            digits = 3;
        }
        if (value >= 10) {
            digits = 2;
        }

        return digits;
    };

    this.chartData = {

        data: liveChart.data,

        chart: {
            backgroundColor: null
        },

        plotOptions: {
            series: {
                dataGrouping: {
                    dateTimeLabelFormats: {
                        millisecond: ['%A, %b %e, %H:%M:%S.%L', '%A, %b %e, %H:%M:%S.%L', '-%H:%M:%S.%L'],
                        second: ['%A, %b %e, %H:%M:%S', '%A, %b %e, %H:%M:%S', '-%H:%M:%S'],
                        minute: ['%A, %b %e %Y %H:%M', '%A, %b %e, %H:%M', '-%H:%M'],
                        hour: ['%A, %b %e %Y', '%A, %b %e, %H:%M', '-%H:%M'],
                        day: ['%A, %b %e %Y', '%A, %b %e', '-%A, %b %e, %Y'],
                        week: ['Week from %A, %b %e, %Y', '%A, %b %e', '-%A, %b %e, %Y'],
                        month: ['%B %Y', '%B', '-%B %Y'],
                        year: ['%Y', '%Y', '-%Y']
                    }
                }
            }
        },

        series: [
            {
                name: liveChart.data.datasets[0].label,
                data: liveChart.data.datasets[0].data,
                color: liveChart.data.datasets[0].backgroundColor,
                threshold: null,
                zIndex: 1,
                tooltip: {
                    valueDecimals: 2
                }
            }
        ],

        tooltip: {
            valuePrefix: liveChart.data.symbol,
            dateTimeLabelFormats: {
                hour: '%A, %b %e %Y',
                minute: '%A, %b %e %Y, %H:%M',
                second: '%A, %b %e %Y, %H:%M'
            }

            /*shared: true,
            useHTML: true,
            formatter: function () {
                var digits = liveChart.getDigits(this.y),
                    value = this.y.toFixed(digits),
                    prefix = '<small>' + Highcharts.dateFormat('%e - %b - %Y',
                        new Date(this.x)) + '</small><br />' + this.points[0].series.name + ': ';

                if (liveChart.data.symbol !== '') {
                    return prefix + '<strong>' + liveChart.data.symbol + value + '</strong>';
                }
                else {
                    return prefix + '<strong>' + value + '</strong>';
                }
            }*/
        },

        xAxis: {
            type: 'datetime'
        },

        responsive: {
            rules: [
                {
                    condition: {
                        maxWidth: 500
                    },
                    chartOptions: {
                        chart: {
                            height: 500
                        },
                        subtitle: {
                            text: null
                        },
                        navigator: {
                            enabled: false
                        },
                        yAxis: {
                            opposite: false
                        }
                    }
                },
                {
                    condition: {
                        minWidth: 501
                    },
                    chartOptions: {
                        chart: {
                            height: 500
                        }
                    }
                }
            ]
        },

        rangeSelector: {
            inputDateFormat: '%Y-%m-%d'
        },

        yAxis: {
            endOnTick: true,
            startOnTick: true,
            showLastLabel: true,
            minPadding: 0,
            maxPadding: 0,
            labels: {
                y: 4,
                formatter: function () {

                    var digits = liveChart.getDigits(this.value);

                    var value = this.value.toFixed(digits);

                    if (liveChart.data.symbol !== '') {
                        return liveChart.data.symbol + value;
                    }
                    else {
                        return value;
                    }

                }
            }
        }
    };

    this.chartData.series[1] = {
        name: 'Low/High',
        data: liveChart.data.datasets[0].ranges,
        type: 'arearange',
        lineWidth: 0,
        linkedTo: ':previous',
        color: liveChart.data.datasets[0].backgroundColor,
        fillOpacity: 0.3,
        zIndex: 0,
        tooltip: {
            valueDecimals: 2
        },
        marker: {
            enabled: false
        }
    };

    this.myChart = new Highcharts.stockChart(ctx, this.chartData, function (chart) {
        // apply the date pickers
        setTimeout(function () {
            $('input.highcharts-range-selector', $(chart.container).parent()).datepicker({
                dateFormat: 'yy-mm-dd',
                changeMonth: true,
                changeYear: true,
                showButtonPanel: true,
                showOtherMonths: true,
                yearRange: "-500:+0",
                minDate: new Date(chart.xAxis[0].dataMin),
                maxDate: new Date(chart.xAxis[0].dataMax)
            });
        }, 0);
    });
};

export {LiveChart};